import React, { Component } from 'react';
import styled from 'styled-components';
import { media } from '../../utils/style';
import H4 from '../H4';
import H5 from '../H5';
import P from '../P';

const SkillsWrap = styled.div`
  background-color: ${props => props.theme.main};
  color: ${props => props.theme.white};
  padding: 75px 10px;
`;

const Headings = styled.div`
  margin: 0 auto 20px;
  max-width: 800px;
`;

const MainContent = styled.div`
  margin: 0 auto;
  max-width: 800px;

  a {
    color: ${props => props.theme.white};
  }

  p {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export default class SkillsSection extends Component {
  render() {
    return (
      <SkillsWrap>
        <Headings>
          <H4 big inverse>
            Hi again, Thanks for scrolling down to know more about me.
          </H4>
        </Headings>
        <MainContent>
          <P big inverse>
            My journey with JavaScript started in 2010 when I was at my
            university doing my bachelors in Information and Communication
            Technology. Since then I have been working with JavaScript
            delivering{' '}
            <a
              href="https://developer.mozilla.org/en-US/docs/Web/Accessibility"
              target="_blank"
              rel="noopener"
              title="Accessible Web Apps"
            >
              accessible
            </a>{' '}
            and{' '}
            <a
              href="https://en.wikipedia.org/wiki/Progressive_Web_Apps"
              target="_blank"
              rel="noopener"
              title="Progressive Web Apps"
            >
              progressive
            </a>{' '}
            web apps.
          </P>

          <P big inverse>
            I am an optimistic level-headed person who proportionates smartness
            and hard work. I love to solve problems and I can learn &amp; adapt
            to new technologies quickly. I have worked for both startups &amp;
            corporate companies and have valuable experience from both
            environments. I blend in with teams easily and I look for a good
            relationship with people I come across. I am always open to
            discussion &amp; feedback and I update myself regularly.
          </P>

          <P big inverse>
            I love working with{' '}
            <a
              href="https://reactjs.org/"
              target="_blank"
              rel="noopener"
              title="React JavaScript Framework"
            >
              React
            </a>,{' '}
            <a
              href="https://vuejs.org/"
              target="_blank"
              rel="noopener"
              title="Vue JavaScript Framework"
            >
              Vue.js
            </a>{' '}
            and{' '}
            <a
              href="https://nodejs.org/en/"
              target="_blank"
              rel="noopener"
              title="Node.js"
            >
              Node.js
            </a>. I have also worked extensively with{' '}
            <a
              href="https://www.ruby-lang.org/en/"
              target="_blank"
              rel="noopener"
              title="Ruby Programming Language"
            >
              Ruby
            </a>{' '}
            and{' '}
            <a
              href="https://rubyonrails.org/"
              target="_blank"
              rel="noopener"
              title="Ruby on Rails"
            >
              Rails
            </a>. I believe in test-driven development & automation. I automate
            most of my workflow using{' '}
            <a
              href="https://webpack.js.org/"
              target="_blank"
              rel="noopener"
              title="Webpack Module Bundler "
            >
              Webpack
            </a>,{' '}
            <a
              href="https://docs.npmjs.com/misc/scripts"
              target="_blank"
              rel="noopener"
              title="npm-scripts"
            >
              npm-scripts
            </a>,{' '}
            <a
              href="https://gruntjs.com/"
              target="_blank"
              rel="noopener"
              title="Grunt - Task Runner"
            >
              grunt
            </a>, and{' '}
            <a
              href="https://gulpjs.com/"
              target="_blank"
              rel="noopener"
              title="Gulp - Automate your workflow"
            >
              gulp
            </a>. I am familiar with Photoshop, Illustrator and cloud platforms
            like AWS, Google Cloud Platform and Heroku.
          </P>
        </MainContent>
      </SkillsWrap>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IndexComponents/SkillsSection.js